import { createFileRoute, notFound } from "@tanstack/react-router";

import { publicShareHead } from "@/lib/share-token";

// Every other `/public-spec/…` path is Page not found — **to an anonymous
// visitor too**, without a sign-in first and without the public header, as
// modsy's `*` error page answers outside every layout and auth gate
// (`App.tsx:118`). The authed catch-all would send a stranger to sign in
// instead.
//
// The case that matters is the 2023 SpecSheet link, `/public-spec/<n>` (research
// §5.1, shape e): modsy unrouted it in 2025, so its 94 links already land on the
// error page there (ADR-0019 decision 4). The pinned page
// (`/public-spec/$specId/versions/$versionId`) and the resolver are more
// specific and win.
export const Route = createFileRoute("/public-spec/$")({
  // The share pages' head too — `noindex` and the `strict-origin` referrer —
  // because a token can ride this URL as well: a retired link's.
  head: () => ({ meta: [...publicShareHead().meta, { title: "Page not found" }] }),
  loader: () => {
    throw notFound();
  },
});
